import _ from "lodash";
import PropTypes from "prop-types";
import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { getProfileSchedulesByType } from "../../../store/schedules";
import { getWeekdays } from "./scheduler.helpers";
import { SchedulerForm } from "./schedulerForm/SchedulerForm";
import { SchedulerContext } from "./SchedulerContext";
import { getIs24hourFormat } from "../../../store/attributes";

export const Scheduler = ({ profileId, type }) => {
  const schedules = useSelector(
    getProfileSchedulesByType(profileId, type),
    _.isEqual,
  );
  const timeFormat24h = useSelector(getIs24hourFormat);
  const weekdays = useSelector(getWeekdays, shallowEqual);
  const maxSchedulesCount = 7;

  const scheduleContext = useMemo(
    () => ({ profileId, type, timeFormat24h, weekdays, maxSchedulesCount }),
    [profileId, type, timeFormat24h, weekdays, maxSchedulesCount],
  );

  return (
    <SchedulerContext.Provider value={scheduleContext}>
      <SchedulerForm schedules={schedules} />
    </SchedulerContext.Provider>
  );
};

Scheduler.propTypes = {
  profileId: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
